import { render } from "./ResponseRates.vue?vue&type=template&id=1a852988"
import script from "./ResponseRates.vue?vue&type=script&lang=js"
export * from "./ResponseRates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__